import * as api from '../api/index'

import { ADD_NEW, UPDATE, DELETE, GET_INVOICE, FETCH_INVOICE_BY_USER, FETCH_ALL,START_LOADING, END_LOADING,FETCH_PAGE, FETCH_INVOICES_FOR_DATE_RANGE, FETCH_INVOICES_BY_AGENT, FETCH_INVOICES_BY_CLIENT } from './constants'

export const getInvoices = (params = {}) => async (dispatch)=> {
    try {
        dispatch({ type: START_LOADING })
        
        // Build query string with parameters
        let url = '/invoices';
        if (params.limit) {
            url += `?limit=${params.limit}`;
        }
        
        const { data } = await api.fetchInvoices(url)
        console.log(data)
        dispatch({ type: FETCH_ALL, payload: data })
        dispatch({ type: END_LOADING })
    } catch (error) {
        console.log(error)
    }
}
export const getInvoicesByPage =
  (page, rowsPerPage, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchInvoicesByPage({
        page,
        rowsPerPage,
        startDate,
        endDate,
      });

      dispatch({ type: FETCH_PAGE, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error);
    }
  };
export const getInvoicesByUser =(searchQuery) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING })
    const  { data: { data } } = await api.fetchInvoicesByUser(searchQuery)
      dispatch({ type: FETCH_INVOICE_BY_USER, payload: data });
      dispatch({ type: END_LOADING })
    } catch (error) {
      console.log(error.response)
      
    }
  }


export const getInvoice = (id) => async (dispatch)=> {

    const user = JSON.parse(localStorage.getItem('profile'))

    try {
        const { data } = await api.fetchInvoice(id)
       // console.log("getInvoicedata",data)
        if (!data) return
        const businessDetails = await api.fetchProfilesByUser(user.result._id)
       // console.log("Business Details: " ,businessDetails)
        const invoiceData = {...data, businessDetails}

       // console.log("invoice Data",invoiceData)
        dispatch({ type: GET_INVOICE, payload: invoiceData  })
    } catch (error) {
        console.log(error.response)
    }
}

export const createInvoice =(invoice, history) => async (dispatch) => {
    try {
        console.log("Create Invoice Called")
        dispatch({ type: START_LOADING })
        const { data } = await api.addInvoice(invoice)
        console.log("Created Invoice Data",data)
        dispatch({ type: ADD_NEW, payload: data })
        history.push(`/invoice/${data._id}`)
        dispatch({ type: END_LOADING })
    } catch (error) {
        console.log(error)
    }
}

export const updateInvoice =(id, invoice) => async (dispatch) => {

    try {
        const { data } = await api.updateInvoice(id, invoice)
        dispatch({ type: UPDATE, payload: data })
        
    } catch (error) {
        console.log(error)
    }
}

export const deleteInvoice =(id, openSnackbar) => async (dispatch) => {
    try {
        await api.deleteInvoice(id)

        dispatch({type: DELETE, payload: id})
        openSnackbar("Order deleted successfully")
    } catch (error) {
        console.log(error.response)
    }
}

export const getInvoicesForDateRange = (startDate, endDate) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.fetchInvoicesForDateRange(startDate, endDate);
        dispatch({ type: FETCH_INVOICES_FOR_DATE_RANGE, payload: data });
        dispatch({ type: END_LOADING });
    } catch (error) {
        console.log(error);
        dispatch({ type: END_LOADING });
    }
};

export const getInvoicesByAgent = (agentCode) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.fetchInvoicesByAgent(agentCode);
        dispatch({ type: FETCH_INVOICES_BY_AGENT, payload: data });
        dispatch({ type: END_LOADING });
    } catch (error) {
        console.log(error);
        dispatch({ type: END_LOADING });
    }
};

export const getInvoicesByClient = (clientId) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.fetchInvoicesByClient(clientId);
        dispatch({ type: FETCH_INVOICES_BY_CLIENT, payload: data });
        dispatch({ type: END_LOADING });
    } catch (error) {
        console.log(error);
        dispatch({ type: END_LOADING });
    }
};